// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IdcardOutlinedSvg from "@ant-design/icons-svg/es/asn/IdcardOutlined";
import AntdIcon from '../components/AntdIcon';

var IdcardOutlined = function IdcardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: IdcardOutlinedSvg
  }));
};

IdcardOutlined.displayName = 'IdcardOutlined';
export default React.forwardRef(IdcardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/IdcardOutlined.js
// module id = 1335
// module chunks = 0